import { render } from "./RiArrowRight.vue?vue&type=template&id=070e69a0"
import script from "./RiArrowRight.vue?vue&type=script&lang=js"
export * from "./RiArrowRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiArrowRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "070e69a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('070e69a0', __exports__)) {
    api.reload('070e69a0', __exports__)
  }
  
  module.hot.accept("./RiArrowRight.vue?vue&type=template&id=070e69a0", () => {
    api.rerender('070e69a0', render)
  })

}


export default __exports__